import(/* webpackMode: "eager" */ "/vercel/path0/app/(global)/inscription/page.tsx");
